module.exports = __webpack_public_path__ + "static/media/tile-price-4.dbe396ea.jpg";